import {
    DISMISS_ALERT,
    DISMISS_ALERT_FAIL,
    DISMISS_ALERT_SUCCESS,
    RESET_DISMISS_ALERT
} from './actionTypes';

export const dismissAlert = args => ({
    type: DISMISS_ALERT,
    payload: args
});

export const dismissAlertSuccess = response => ({
    type: DISMISS_ALERT_SUCCESS,
    payload: response
});

export const dismissAlertFail = error => ({
    type: DISMISS_ALERT_FAIL,
    payload: error
});

export const resetDismissAlert = () => ({
    type: RESET_DISMISS_ALERT
});
